module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic-bc511bacf828ac9e833e6208292066b8.woff2";